<section>
    <div class="page-title">
        <h2>{{ pageData.title }}</h2>
    </div>
    <p class="main-subtitle">
        {{ pageData.subtitle }}
    </p>
    <p class="mexcan-header">
        {{ callFromUSContent.header }}
    </p>
    <p class="mexcan-description">
        {{ callFromUSContent.description }}
    </p>
    <div class= "rates-link" >
        <a class="xm-btn-link-light" [uiSref]="pageData.searchRatesLinkCta" [uiParams]="uiParams">{{ pageData.searchRatesLink }}</a>
    </div>
    <div class="mex-card">
        <xm-media-image aria-hidden="true" class="mex-can-img" [imageOptions]="mexCanImage" size="auto"></xm-media-image>
        <div class="card-details">
            <p class="subtitle">{{ pageData.cardTitle }}</p>
            <span class="display-price">{{ mexCanData.displayPrice }}</span>
            <p class="card-description">
                {{ callFromUSContent.cardDescription }}
            </p>
            <div *ngIf="isPendingRemoval" class="active-until-info">
                <p>{{ callFromUSContent.activeUntilInfo }}</p>
            </div>
        </div>
        <div class="icon-wrapper" role="status" [attr.aria-label]="pageData.cardTitle + ' is ' + callFromUSContent.statusBadge">
            <xm-media-image *ngIf="showActiveIcon" [imageOptions]="inUseIcon" class="use-icon"></xm-media-image>
            <span class="status" [ngClass]="{ 'status-tune': showActiveIcon }">
                {{ callFromUSContent.statusBadge }}
            </span>
        </div>
        <button class="xm-btn-secondary-light card-btn" (click)="launchCanMexFlow()">
            {{ callFromUSContent.cardButton }}
        </button>
    </div>
    <p class="support-header">
        {{ pageData.supportHeader }}
    </p>
    <div class="support-links" *ngFor="let link of pageData.supportLinks">
        <xm-decorated-text class="xm-btn-link-light" [inputString]="link"></xm-decorated-text>
    </div>
</section>
